@if (popupEnabled) {
    <span class="popup-button">
        <eff-icon
            [icon]="icon"
            size="sixteen-size"
            id="popup-button"
            [attr.data-uiid]="buttonUiid"
            (click)="openPopup()"
        ></eff-icon>
    </span>
}
<app-eff-textarea-field
    [label]="label"
    [model]="model"
    [uiid]="uiid"
    [bordered]="bordered"
    [disabled]="disabled"
    [formController]="formController"
    (modelChange)="onModelChanged($event)"
></app-eff-textarea-field>
